<template>
  <v-app>
    <v-main>
      <core-tile/>
    </v-main>
  </v-app>
</template>

<script>
import CoreTile from './components/CoreTile';

export default {
  name: 'cald_ds',

  components: {
    CoreTile,
  },

  data: () => ({
    //
  }),
};
</script>

<style>
.selected-btn {
  background-color: rgb(74, 165, 74) !important;
  border-color: rgb(74, 165, 74) !important;
  color: #ffffff !important;
}

.unselected-btn {
  background-color: rgb(63, 103, 123) !important;
  border-color: rgb(63, 103, 123) !important;
  color: #ffffff !important;
}

.selected-btn:disabled {
  background-color: rgb(74, 165, 74, 0.5) !important;
  border-color: rgb(74, 165, 74, 0.5) !important;
}
.unselected-btn:disabled {
  background-color: rgb(63, 103, 123, 0.47) !important;
  border-color: rgb(63, 103, 123, 0.47) !important;
}
</style>
